var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerWithHeaderAndBack',[_c('div',{staticClass:"text-center m-auto py-4"},[_c('h1',{staticClass:"text-3xl text-white-1 text-center"},[_vm._v(_vm._s(_vm.$t('speakers_count.title')))]),_c('SpeakersCountForm',{staticClass:"mt-6"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }